import { HomeOutlined, RightOutlined } from '@ant-design/icons'
import { Card, Flex, Tag, Typography } from 'antd'
import { PropertyActivityPtoType, PtoItemType } from 'Modules'

import { PROPERTY_ACTIVITY_PTO_TYPE_LABEL } from 'constants/property-activities'
import { PTOTypeEnum } from 'constants/pto'

const { Text } = Typography

interface PtoCardProps {
  pto: PtoItemType
  onClick: (pto: PtoItemType) => void
}

const getPtoLocation = (pto: PtoItemType): string => {
  return pto.propertyItems?.location || pto.country || '-'
}

const getPtoType = (pto: PtoItemType): PropertyActivityPtoType => {
  return pto.ptoType === PTOTypeEnum.RENTAL_PTO ? PTOTypeEnum.RENTAL_PTO : PTOTypeEnum.PTO
}

export const PtoCard = ({ pto, onClick }: PtoCardProps) => {
  const type = getPtoType(pto)

  return (
    <Card
      hoverable
      className="property-activities__pto-card"
      onClick={() => onClick(pto)}
      styles={{ body: { padding: 20 } }}
    >
      <Flex justify="space-between" align="flex-start" style={{ marginBottom: 16 }}>
        <div className="property-activities__pto-card-icon">
          {pto.thumbnail ? <img src={pto.thumbnail} alt={pto.fullName} /> : <HomeOutlined />}
        </div>
        <RightOutlined style={{ color: '#9ca3af' }} />
      </Flex>

      <div className="property-activities__pto-card-name">{pto.fullName}</div>
      <Text type="secondary" className="property-activities__pto-card-location">
        {getPtoLocation(pto)}
      </Text>

      <div className="property-activities__pto-card-divider" />

      <Flex justify="space-between" align="center">
        <Flex vertical>
          <Text type="secondary" style={{ fontSize: 12 }}>
            Activities
          </Text>
          <Text strong style={{ fontSize: 16 }}>
            {pto.activities ?? 0}
          </Text>
        </Flex>

        <Tag
          color={type === PTOTypeEnum.RENTAL_PTO ? 'blue' : 'default'}
          style={{ marginRight: 0, borderRadius: 12 }}
        >
          {PROPERTY_ACTIVITY_PTO_TYPE_LABEL[type]}
        </Tag>
      </Flex>
    </Card>
  )
}
